<!-- Footer -->
<footer class="text-center text-lg-start bg-light text-muted footer foter" >
    <!-- Section: Social media -->
   
    <!-- Section: Links  -->
  
    <!-- Copyright -->
    <div class="text-center p-1 footercont">    
      <a class="text-reset fw-bold">© GBSHSE 2023, All Rights Reserved.</a><br>
    </div>
    <!-- Copyright -->
  </footer>
  <!-- Footer -->